enum AddressType {
  business = 'business',
  residential = 'residential',
}

export default AddressType;
